module.exports = __webpack_public_path__ + "img/action-unmute.22275dad.svg";